{
  "version": 1,
  "asset_id": "9baed1ea-6a90-4bae-ab1b-2699227fa3aa",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/9baed1ea-6a90-4bae-ab1b-2699227fa3aa/smartlane-timeline-setup.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/9baed1ea-6a90-4bae-ab1b-2699227fa3aa/smartlane-timeline-setup.png",
  "original_filename": "smartlane-timeline-setup.png",
  "size": 744511,
  "content_type": "image/png",
  "created_at": "2026-08-25T15:44:21Z"
}
